module.exports = __webpack_public_path__ + "img/hazte-socio.d582ddca.png";